import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Add a project team member
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestCrawlURL = packet => {
  return {
    type: 'REQUEST_CRAWL_URL',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCrawlURLSuccess = data => ({
  type: 'RECEIVE_CRAWL_URL_SUCCESS',
  data
})

export const receiveCrawlURLFail = data => ({
  type: 'RECEIVE_CRAWL_URL_FAIL',
  data
})

export const tryToCrawlURL = (packet, callback) => (dispatch, getState) => {

  dispatch(requestCrawlURL(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/wrench/url/', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveCrawlURLSuccess(json));
      if(callback) callback(json);
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveCrawlURLFail({errors:e, lastSubmit: packet}));
      if(callback) callback(e);
    })
}
